import "./PortfolioRoadmap.css";

import { EditLightIcon, EmptyRoadmapIcon, RoundedPlusSignIcon } from "../../../../assets";
import { Button, Column, PortfolioRoadmap as PortfolioRoadmapWidget, Row } from "../../../../widget";
import { SelectDealsModal } from "./components";
import { usePortfolioRoadmapPage } from "./usePortfolioRoadmapPage";

const PortfolioRoadmap = (): JSX.Element => {
  const {
    errors,
    data,
    dealsMultiSelectData,
    roadmapDealUuids,
    setRoadmapDealUuids,
    showAddDealsModal,
    setShowAddDealsModal,
    closeSelectDealsModal,
    onSaveDealsSelectData,
    isLoading,
    setIsLoading,
    fetchSelectData,
    hasData,
  } = usePortfolioRoadmapPage();

  return (
    <div className="PortfolioRoadmapWrapper">
      <Row spacingV="ml">
        <Column span={12}>
          <div className="PortfolioRoadmapHeader">
            <h2 className="PortfolioRoadmapTitle">Roadmap</h2>
            {hasData && (
              <Button
                text="Edit roadmap"
                icon={<EditLightIcon />}
                iconPosition="left"
                corners="rounded"
                onClick={() => setShowAddDealsModal(true)}
              />
            )}
          </div>
        </Column>
      </Row>
      {(hasData || isLoading) && (
        <PortfolioRoadmapWidget data={data} isLoading={isLoading} setIsLoading={setIsLoading} headerLabel="Deal" />
      )}
      {!hasData && !isLoading && (
        <div className="EmptyRoadmap">
          <EmptyRoadmapIcon />
          <h1>Your roadmap is almost ready</h1>
          <p className="body1">Add deals to populate your roadmap.</p>
          <Button
            className="AddDealsButton"
            text="Add deals"
            icon={<RoundedPlusSignIcon className="RoundedPlusSignIcon" />}
            iconPosition="left"
            onClick={() => setShowAddDealsModal(true)}
            corners="rounded"
          />
        </div>
      )}
      <SelectDealsModal
        errors={errors}
        roadmapDealUuids={roadmapDealUuids}
        setRoadmapDealUuids={setRoadmapDealUuids}
        dealsMultiSelectData={dealsMultiSelectData}
        onSaveDealsSelectData={onSaveDealsSelectData}
        show={showAddDealsModal}
        closePanel={closeSelectDealsModal}
        fetchSelectData={fetchSelectData}
      />
    </div>
  );
};

export default PortfolioRoadmap;
